import React, { useEffect, useState } from 'react';
import type { ICellRendererParams } from 'ag-grid-community';
import { RootState, useDispatch, useSelector } from '../../redux/store';

/**
 * organizationIdから組織名を表示するレンダラ
 * @param params: ICellRendererParams
 * @returns React.ReactElement
 */
const OrganizationIdCellRenderer = (params: ICellRendererParams): React.ReactElement => {
  // console.log(params);
  const organizationId: number = params.value;
  const { organizations } = useSelector((state: RootState) => state.organization);
  const [organizationName, setOrganizationName] = useState<string>('');

  // SIDE EFFECT
  // ================================================================================

  /**
   * 確認用
   */
  // useEffect(() => {
  // }, []);

  useEffect(() => {
    if (organizations !== undefined) {
      const name: string | undefined = organizations.find((organization) => organization.id === organizationId)?.organizationSuffixName;
      setOrganizationName(name ?? String(organizationId));
    }
  }, [organizations]);

  // EVENT HANDLER
  // ================================================================================

  // VIEW
  // ================================================================================

  return <div className="organization-name">{organizationName}</div>;
};

export default OrganizationIdCellRenderer;
